import { DataForSearchTour } from 'entities/tour/models/search-tour'

import { SpecialTour } from 'shared/api/tours/search'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'

export const preparedDataForSpecialTour = (
  tour: SpecialTour,
): DataForSearchTour => {
  return {
    duration: tour?.nights,
    departure: {
      id: String(tour?.town_from?.id || ''),
      name: tour?.town_from?.name || '',
    },
    resorts:
      tour?.towns_to?.map((item) => ({
        id: item.id,
        name: item.name,
        state: Number(tour?.state?.id) || 0,
        state_name: tour?.state?.name || '',
      })) || [],
    country: {
      id: String(tour?.state?.id || ''),
      state_id: Number(tour?.state?.id) || 0,
      name: tour?.state?.name,
    },
    flight: {
      startDay: dateFormat(tour?.checkin_date, DATE_FORMAT_LIST.YEAR_FULL_DATE),
    },
    passengers: {
      adults: tour?.adult,
    },
    is_flexible_date: false,
    is_flexible_nights: false,
  }
}
